/** 信用卡活动专区 */
<template>
  <div>
    <!-- 轮播图 -->
    <div v-if="adTopArr.length > 0">
      <van-swipe
        class="swiper"
        :autoplay="3000"
        indicator-color="#7999FF"
        :stop-propagation="false"
      >
        <van-swipe-item v-for="(item, index) in adTopArr" :key="index">
          <img
            class="swiper-img"
            :src="item.appIconUrl"
            @click="adEvent($event, item)"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 钱包权益 -->
    <div class="wallet-equity-box">
      <div class="top-box">
        <div class="title">钱包权益</div>
        <div class="tag">钱包用户 特权福利</div>
      </div>
      <div class="equity-list">
        <div
          v-for="item in equityList"
          :key="item.id"
          class="equity-item"
          @click="goPage(item)"
        >
          <img :src="item.img" alt="钱包权益" class="equity-img" />
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="bottom-swiper" v-if="adBottomArr.length > 0">
      <van-swipe
        class="swiper"
        :autoplay="3000"
        indicator-color="#95A7BC"
        :stop-propagation="false"
      >
        <van-swipe-item v-for="(item, index) in adBottomArr" :key="index">
          <img
            class="swiper-img"
            :src="item.appIconUrl"
            @click="adEvent($event, item)"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem, Toast } from 'vant'
import { setStore } from '@/utils/index'
import { queryAd } from '@/api/cmbCreditCard'
export default {
  name: 'cmbCreditCardActivityZone',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      adTopArr: [],
      adBottomArr: [],
      equityList: [
        {
          id: 1,
          img:
            'https://oss.aqdpay.com/appweb/cmbCreditCard/activityZone/list1.png', // banner图片
          path: '/cmbcActive' // 跳转路由
        }
        // {
        //   id: 2,
        //   img:
        //     'https://oss.aqdpay.com/appweb/cmbCreditCard/activityZone/list2.png', // banner图片
        //   path: '/cloudFlashPayment' // 跳转路由
        // }
      ] // 钱包权益列表
    }
  },
  created () {
    this.token = this.$route.query.token
    if (this.token) {
      setStore('token', this.token)
    }
    this.getTopBanner()
    this.getBottomBanner()
  },
  methods: {
    // 获取顶部banner
    getTopBanner () {
      const query = {
        placeId: 249, // 广告位ID 固定值
        version: '-1', // 固定为-1
        platformType: 3 // 固定为3（代表H5）
      }
      queryAd(query).then(res => {
        const resData = res.data
        if (resData.code === 200) {
          this.adTopArr = resData.result
        } else {
          Toast({ message: resData.message, duration: 3000 })
        }
      })
    },
    // 获取顶部banner
    async getBottomBanner () {
      const query = {
        placeId: 250, // 广告位ID 固定值
        version: '-1', // 固定为-1
        platformType: 3 // 固定为3（代表H5）
      }
      queryAd(query).then(res => {
        const resData = res.data
        if (resData.code === 200) {
          this.adBottomArr = resData.result
        } else {
          Toast({ message: resData.message, duration: 3000 })
        }
      })
    },
    adEvent (event, data) {
      console.log('event-item', event, data)
      dsBridge.call('callNativeViewLifeCycle', {
        androidGoPage: data.androidGoPage,
        iosGoPage: data.iosGoPage,
        appId: data.appId,
        appType: data.appType,
        appStartUrl: data.appStartUrl,
        authorize: data.authorize,
        addToolbar: data.addToolbar
      })
    },
    goPage (item) {
      let path = item.path
      this.$router.push({
        path,
        query: {
          token: this.token
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper {
  width: 100%;

  .swiper-img {
    width: 100%;
    height: 100%;
  }

  /deep/ {
    .van-swipe-item {
      display: flex;
    }

    .van-swipe__indicators {
      bottom: 16px;
    }

    .van-swipe__indicator:not(:last-child) {
      margin-right: 8px;
    }

    .van-swipe__indicator {
      width: 8px;
      height: 8px;
    }
  }
}

.wallet-equity-box {
  padding: 15px;

  .top-box {
    display: flex;
    align-items: baseline;
  }

  .title {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #333;
    line-height: 22px;
    margin-right: 8px;
  }

  .tag {
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #999;
    line-height: 17px;
  }

  .equity-item {
    margin-top: 15px;
  }

  .equity-img {
    width: 100%;
  }
}

.bottom-swiper {
  padding: 0 15px;
  margin-bottom: 15px;

  .swiper-img {
    border-radius: 8px;
  }

  /deep/ {
    .van-swipe__indicators {
      bottom: 4px;
    }

    .van-swipe__indicator:not(:last-child) {
      margin-right: 4px;
    }

    .van-swipe__indicator {
      width: 6px;
      height: 2px;
      border-radius: 1px;
    }
  }
}
</style>
